import React from "react"
import { Box } from "@components/Layout"
import { TitleL, Paragraph } from "@components/Typography"
import { useIntl } from "@components/Intl"
import { Button } from "@components/Buttons"
import IntlLink from "@components/Intl/IntlLink"
import * as S from "./elements"

interface Props {
  loadError?: boolean
}

const EmptyState: React.FC<Props> = ({ loadError = false }) => {
  const { messages } = useIntl()

  return (
    <S.Grid>
      <div></div>
      <S.Row
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
      >
        {loadError ? (
          <>
            <TitleL>{messages.global.oops}</TitleL>
            <Box maxWidth="27rem" textAlign="center" pb="3">
              <Paragraph>{messages.configurator.loadError}</Paragraph>
            </Box>
          </>
        ) : (
          <>
            <TitleL>{messages.configurator.configureYourChoices}</TitleL>
            <Box maxWidth="27rem" textAlign="center" pb="3">
              <Paragraph>
                {messages.configurator.configureYourChoicesDescription}
              </Paragraph>
            </Box>
            <IntlLink
              href={messages.navigation.collection.url}
              as={messages.navigation.collection.url}
            >
              <Button maxWidth="22rem" variant="purple">
                {messages.configurator.viewCollectionAndConfigure}
              </Button>
            </IntlLink>
          </>
        )}
      </S.Row>
    </S.Grid>
  )
}

export default EmptyState
